<!--Copy right - © 2024 tecera gmbh-->
<script>
    import ToggleButton from "../../buttons/ToggleButton.svelte";
    import { fade } from "svelte/transition";
    export let latitude;
    export let longitude;
    export let classes = "";
    export let set_coords;
    export let setManCoords;
    let is_generate_coords_button_disabled = false;

    function set_coords2() {
        set_coords();
        is_generate_coords_button_disabled = true;
        setTimeout(function () {
            is_generate_coords_button_disabled = false;
        }, 2000);
    }
</script>

<ToggleButton
    {classes}
    id="setManCoords"
    label="Koordinaten manuell setzen"
    bind:toggle={setManCoords}
/>

{#if setManCoords}
    <div class="form-row" transition:fade={{ duration: 300 }}>
        <div class="form-group col-md-6">
            <label for="latitude">Latitude</label>
            <input
                bind:value={latitude}
                id="latitude"
                class="form-control py-1 edit_field coords"
                type="text"
                placeholder="Latitude"
                disabled={!setManCoords}
                aria-label="Search"
                maxlength="50"
                autocomplete="off"
            />
        </div>
        <div class="form-group col-md-6">
            <label for="longitude">Longitude</label>
            <input
                bind:value={longitude}
                id="longitude"
                class="form-control py-1 edit_field coords"
                type="text"
                placeholder="Longitude"
                disabled={!setManCoords}
                aria-label="Search"
                maxlength="50"
                autocomplete="off"
            />
        </div>
    </div>

    <!-- Koordinaten aus  -->
    <div class="input-group mb-4 mt-2" transition:fade={{ duration: 300 }}>
        <button
            class="btn btn-secondary btn-normal"
            id="coords_from_address"
            on:click={() => set_coords2()}
            disabled={is_generate_coords_button_disabled}
        >
            Koordinaten aus Addresse generieren
        </button>
    </div>
{/if}
